import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-service-card',
  templateUrl: './service-card.component.html',
  styleUrl: './service-card.component.scss',
})
export class ServiceCardComponent {
  @Input() index!: any;
  @Input() serviceDetails!: any;
  redirect() {
    window.location.href = 'https://www.claracareservices.com';
  }
}
export interface PlatforFacility {}
